(function() {
  var ATC, Backbone, _;

  window.ATC = {
    Collections: {},
    Models: {},
    Views: {},
    Routers: {},
    init: function() {
      this.cart = new ATC.Models.Cart();
      this.cart_view = new ATC.Views.Cart({
        model: this.cart
      });
      this.login_view = new ATC.Views.Login();
      this.search_view = new ATC.Views.Search();
      this.views = [];
      this.render_views();
      return this.bindEvents();
    },
    bindEvents: function() {
      var self;
      this.mobileDetect();
      self = this;
      return $(window).on("scroll", (function(_this) {
        return function() {
          return self.mobileDetect();
        };
      })(this));
    },
    mobileDetect: function() {
      var diff;
      diff = iosInnerHeight() - window.innerHeight;
      return $('[data-mobile-detect]').each(function() {
        return $(this).css({
          'margin-bottom': diff
        });
      });
    },
    render_views: function() {
      var i, len, ref, view;
      ref = this.views;
      for (i = 0, len = ref.length; i < len; i++) {
        view = ref[i];
        view.undelegateEvents();
      }
      delete this.views;
      this.views = [];
      $("[data-navigation]").each((function(_this) {
        return function(index, element) {
          return _this.views.push(new ATC.Views.Nav({
            el: element
          }));
        };
      })(this));
      $("[data-header]").each((function(_this) {
        return function(index, element) {
          return _this.views.push(new ATC.Views.Header({
            el: element
          }));
        };
      })(this));
      $("[data-newsletter]").each((function(_this) {
        return function(index, element) {
          return _this.views.push(new ATC.Views.Newsletter({
            el: element
          }));
        };
      })(this));
      $("[data-hero]").each((function(_this) {
        return function(index, element) {
          return _this.views.push(new ATC.Views.Hero({
            el: element
          }));
        };
      })(this));
      $("[data-carousel]").each((function(_this) {
        return function(index, element) {
          return _this.views.push(new ATC.Views.Carousel({
            el: element
          }));
        };
      })(this));
      $("[data-video]").each((function(_this) {
        return function(index, element) {
          return _this.views.push(new ATC.Views.Video({
            el: element
          }));
        };
      })(this));
      $("[data-footer]").each((function(_this) {
        return function(index, element) {
          return _this.views.push(new ATC.Views.Footer({
            el: element
          }));
        };
      })(this));
      $("[data-filters]").each((function(_this) {
        return function(index, element) {
          return _this.views.push(new ATC.Views.Filters({
            el: element
          }));
        };
      })(this));
      $("[data-slider]").each((function(_this) {
        return function(index, element) {
          return _this.views.push(new ATC.Views.Slider({
            el: element
          }));
        };
      })(this));
      $("[data-feed]").each((function(_this) {
        return function(index, element) {
          return _this.views.push(new ATC.Views.Feed({
            el: element
          }));
        };
      })(this));
      $("[data-map]").each((function(_this) {
        return function(index, element) {
          return _this.views.push(new ATC.Views.Map({
            el: element
          }));
        };
      })(this));
      $("[data-product-id]").each((function(_this) {
        return function(index, element) {
          if (element.hasAttribute("data-custom-size")) {
            return _this.views.push(new ATC.Views.CustomProduct({
              el: element
            }));
          } else {
            return _this.views.push(new ATC.Views.Product({
              el: element
            }));
          }
        };
      })(this));
      $("[data-collection-id]").each((function(_this) {
        return function(index, element) {
          return _this.views.push(new ATC.Views.Collection({
            el: element
          }));
        };
      })(this));
      $("[data-static-page]").each((function(_this) {
        return function(index, element) {
          return _this.views.push(new ATC.Views.StaticPage({
            el: element
          }));
        };
      })(this));
      if ($("[data-show-cart]").length > 0) {
        this.cart_view.show();
      }
      if ($("[data-show-search]").length > 0) {
        this.search_view.show();
      }
      $("[data-fixed-nav]").each((function(_this) {
        return function(index, element) {
          return _this.views.push(new ATC.Views.fixedNav({
            el: element
          }));
        };
      })(this));
      return $("[data-toplevel-cards]").each((function(_this) {
        return function(index, element) {
          return _this.views.push(new ATC.Views.topLevelCards({
            el: element
          }));
        };
      })(this));
    }
  };

  ATC = window.ATC;

  _ = window._;

  Backbone = window.Backbone;

  $(function() {
    return ATC.init();
  });

}).call(this);

(function() {
  ATC.cookies = {
    set: function(name, value, expiry_days) {
      var d, expires;
      d = new Date();
      d.setTime(d.getTime() + (expiry_days * 24 * 60 * 60 * 1000));
      expires = "expires=" + d.toGMTString();
      return document.cookie = "X-" + name + "=" + value + "; " + expires + "; path=/";
    },
    set_for_a_session: function(name, value) {
      return document.cookie = "X-" + name + "=" + value + "; path=/";
    },
    get: function(name) {
      var cookie, cookies, fn, i, len, value;
      name = "X-" + name + "=";
      value = false;
      cookies = document.cookie.split(';');
      fn = function(cookie) {
        cookie = cookie.trim();
        if (cookie.indexOf(name) === 0) {
          return value = cookie.substring(name.length, cookie.length);
        }
      };
      for (i = 0, len = cookies.length; i < len; i++) {
        cookie = cookies[i];
        fn(cookie);
      }
      if (!value) {
        value = null;
      }
      return value;
    },
    "delete": function(name) {
      return document.cookie = 'X-' + name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
    }
  };

}).call(this);

(function() {
  ATC.helpers = {
    get_query_string: function() {
      var m, query_string, regex, result;
      result = {};
      query_string = location.search.slice(1);
      regex = /([^&=]+)=([^&]*)/g;
      m = null;
      while ((m = regex.exec(query_string))) {
        result[decodeURIComponent(m[1])] = decodeURIComponent(m[2]);
      }
      return result;
    }
  };

}).call(this);

(function() {
  Handlebars.registerHelper('money', function(value) {
    if (value != null) {
      return (parseFloat(value) / 100) + " CAD";
    } else {
      return null;
    }
  });

  Handlebars.registerHelper('thumbnail', function(image) {
    return image.replace(/(\.[^.]*)$/, "_medium$1").replace('http:', '');
  });

  Handlebars.registerHelper('truncate', function(string, end) {
    if (string != null) {
      string = string.slice(0, end);
      if (string.length >= end) {
        string += "...";
      }
      return string;
    } else {
      return null;
    }
  });

  Handlebars.registerHelper('first', function(models, options) {
    if ((models != null) && (models[0] != null)) {
      return options.fn(models[0]);
    } else {
      return null;
    }
  });

  Handlebars.registerHelper('last', function(models, options) {
    if ((models != null) && (models[models.length - 1] != null)) {
      return options.fn(models[models.length - 1]);
    } else {
      return null;
    }
  });

  Handlebars.registerHelper('get', function(model, key) {
    if ((model != null) && (model[key] != null)) {
      return model[key];
    } else {
      return null;
    }
  });

  Handlebars.registerHelper('if_get', function(model, key, options) {
    if ((model[key] != null) && model[key]) {
      return options.fn(this);
    } else {
      return null;
    }
  });

  Handlebars.registerHelper('unless_get', function(model, key, options) {
    if ((model[key] != null) && model[key]) {
      return null;
    } else {
      return options.fn(this);
    }
  });

  Handlebars.registerHelper('if_equal', function(left, right, options) {
    debugger;
    if (left === right) {
      return options.fn(this);
    } else {
      return null;
    }
  });

  Handlebars.registerHelper('if_lower', function(left, right, options) {
    if (left < right) {
      return options.fn(this);
    } else {
      return null;
    }
  });

  Handlebars.registerHelper('if_higher', function(left, right, options) {
    if (left > right) {
      return options.fn(this);
    } else {
      return null;
    }
  });

  Handlebars.registerHelper('if_get_equal', function(model, key, right, options) {
    if ((model[key] != null) && model[key] === right) {
      return options.fn(this);
    } else {
      return null;
    }
  });

  Handlebars.registerHelper('unless_equal', function(left, right, options) {
    if (left !== right) {
      return options.fn(this);
    } else {
      return null;
    }
  });

  Handlebars.registerHelper('if_in_array', function(array, right, options) {
    if ((array != null) && _.contains(array, right)) {
      return options.fn(this);
    } else {
      return null;
    }
  });

  Handlebars.registerHelper('date', function(date) {
    date = new Date(date);
    return date.toLocaleDateString();
  });

  Handlebars.registerHelper('if_dates_equal', function(left, right, options) {
    left = new Date(left);
    right = new Date(right);
    if (left.toLocaleDateString() === right.toLocaleDateString()) {
      return options.fn(this);
    } else {
      return null;
    }
  });

  Handlebars.registerHelper('json', function(json) {
    return JSON.stringify(JSON.parse(json), void 0, 2);
  });

  Handlebars.registerHelper('address', function(address) {
    var address_text;
    address_text = "";
    if (address != null) {
      if (address.name != null) {
        address.first_name = address.name;
        address.last_name = "";
      }
      address_text += address.first_name + " " + address.last_name + "<br>" + address.street;
      if ((address.street_continued != null) && address.street_continued !== "") {
        address_text += address.street_continued;
      }
      address_text += " " + address.city + ", " + address.region + ", " + address.country + " " + address.zip;
    }
    return address_text;
  });

  Handlebars.registerHelper('percentage', function(value) {
    return (value * 100) + "%";
  });

  Handlebars.registerHelper('ms', function(value) {
    return (parseFloat(value)).toFixed(3) + "ms";
  });

  Handlebars.registerHelper('plus', function(left, right) {
    return left + right;
  });

  Handlebars.registerHelper('minus', function(left, right) {
    return left - right;
  });

  Handlebars.registerHelper('times', function(value, times) {
    return value * times;
  });

  Handlebars.registerHelper('divide', function(left, right) {
    return left / right;
  });

  Handlebars.registerHelper('encode_uri', function(url) {
    return encodeURIComponent(url);
  });

  Handlebars.registerHelper('first_letter', function(string) {
    if (string != null) {
      return string[0].toUpperCase();
    }
  });

  Handlebars.registerHelper('first_word', function(string) {
    var firstWord, firstWordPosition, rest;
    firstWordPosition = string.indexOf(" ");
    firstWord = string.substr(0, firstWordPosition);
    rest = string.substr(firstWordPosition + 1);
    string = firstWord + ' <span>' + rest + '</span>';
    return string;
  });

  Handlebars.registerHelper('name_from_email', function(email) {
    if (email != null) {
      return email.split("@")[0];
    }
  });

  Handlebars.registerHelper('first_name_from_name', function(name) {
    if (name != null) {
      return name.split(" ")[0];
    }
  });

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  ATC.Models.Cart = (function(superClass) {
    extend(Cart, superClass);

    function Cart() {
      return Cart.__super__.constructor.apply(this, arguments);
    }

    Cart.prototype.url = "/cart.js";

    Cart.prototype.parse = function(response) {
      return response;
    };

    Cart.prototype.initialize = function() {
      return this.fetch();
    };

    Cart.prototype.add = function(id, quantity, data) {
      var finalData;
      if (quantity == null) {
        quantity = 1;
      }
      if (data == null) {
        data = {};
      }
      finalData = {};
      finalData["id"] = id;
      finalData["quantity"] = quantity;
      finalData["properties"] = data;
      return $.ajax("/cart/add.js", {
        method: "POST",
        dataType: "json",
        data: finalData,
        success: (function(_this) {
          return function(response) {
            return _this.fetch();
          };
        })(this),
        error: (function(_this) {
          return function(response) {
            return ATC.cart_view.show_error(response.responseJSON.description);
          };
        })(this)
      });
    };

    Cart.prototype.change = function(key, quantity) {
      var post;
      return post = $.ajax("/cart/change.js", {
        method: "POST",
        dataType: "json",
        data: {
          quantity: quantity,
          id: key
        },
        success: (function(_this) {
          return function(response) {
            return _this.fetch();
          };
        })(this),
        error: (function(_this) {
          return function(response) {
            console.log(response);
            return ATC.cart_view.show_error(response.responseJSON.description);
          };
        })(this)
      });
    };

    Cart.prototype.remove = function(key) {
      return this.change(key, 0);
    };

    return Cart;

  })(Backbone.Model);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  ATC.Collections.Feed = (function(superClass) {
    extend(Feed, superClass);

    function Feed() {
      return Feed.__super__.constructor.apply(this, arguments);
    }

    Feed.prototype.parse = function(response) {
      return response.data;
    };

    Feed.prototype.initialize = function(options) {
      if (options == null) {
        options = {};
      }
      this.url = "https://api.instagram.com/v1/users/" + options.user_id + "/media/recent?access_token=" + options.access_token + "&count=" + options.limit;
      return this.fetch({
        success: function(model, response) {}
      });
    };

    Feed.prototype.sync = function(method, collection, options) {
      var params;
      params = _.extend(options, {
        type: 'GET',
        dataType: 'jsonp',
        url: collection.url,
        processData: false
      });
      return $.ajax(params);
    };

    return Feed;

  })(Backbone.Collection);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  ATC.Views.Slider = (function(superClass) {
    extend(Slider, superClass);

    function Slider() {
      return Slider.__super__.constructor.apply(this, arguments);
    }

    Slider.prototype.current_slide = 0;

    Slider.prototype.events = {
      "click [data-next-slide-button]": "next_slide",
      "click [data-previous-slide-button]": "previous_slide",
      "click [data-slide-marker]": "slide_to"
    };

    Slider.prototype.initialize = function() {
      this.slides_count = this.$el.find("[data-slide]").length;
      return this.render();
    };

    Slider.prototype.render = function() {
      this.$el.find("[data-slide=" + this.current_slide + "]").css("opacity", 1);
      this.reset_autoplay();
      return this;
    };

    Slider.prototype.next_slide = function(e) {
      if (this.current_slide === this.slides_count - 1) {
        return this.slide_to(e, 0);
      } else {
        return this.slide_to(e, this.current_slide + 1);
      }
    };

    Slider.prototype.previous_slide = function(e) {
      if (this.current_slide === 0) {
        return this.slide_to(e, this.slides_count - 1);
      } else {
        return this.slide_to(e, this.current_slide - 1);
      }
    };

    Slider.prototype.slide_to = function(e, index) {
      if (e != null) {
        e.preventDefault();
        e.currentTarget.blur();
        this.reset_autoplay();
      }
      this.current_slide = index;
      this.$el.find("[data-slide-marker]").removeClass("slider__marker--active");
      this.$el.find("[data-slide-marker=" + this.current_slide + "]").addClass("slider__marker--active");
      this.$el.find("[data-slide]").css("opacity", 0.3);
      this.$el.find("[data-slide]").css("transform", "translateX(-" + this.current_slide + "00%)");
      return this.$el.find("[data-slide=" + this.current_slide + "]").css("opacity", 1);
    };

    Slider.prototype.reset_autoplay = function() {
      if (this.el.hasAttribute("data-slider-autoplay")) {
        if (this.interval != null) {
          window.clearInterval(this.interval);
        }
        return this.interval = window.setInterval((function(_this) {
          return function() {
            return _this.next_slide();
          };
        })(this), this.$el.attr("data-slider-autoplay"));
      }
    };

    return Slider;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  ATC.Views.fixedNav = (function(superClass) {
    extend(fixedNav, superClass);

    function fixedNav() {
      return fixedNav.__super__.constructor.apply(this, arguments);
    }

    fixedNav.prototype.initialize = function() {
      this.fixMenu();
      return this.bindEvents();
    };

    fixedNav.prototype.bindEvents = function() {
      return $(window).scroll((function(_this) {
        return function() {
          return _this.fixMenu();
        };
      })(this));
    };

    fixedNav.prototype.setInitialFixedPosition = function() {
      var $nav, fixedPosition;
      if (this.$el.data('fixed-position') == null) {
        $nav = this.$el.find('nav');
        fixedPosition = $nav.offset().top - $(window).scrollTop() + $nav.innerHeight();
        return this.$el.data('fixed-position', fixedPosition);
      }
    };

    fixedNav.prototype.unsetInitialFixedPosition = function() {
      return this.$el.removeAttr('data-fixed-position');
    };

    fixedNav.prototype.fixMenu = function() {
      var $nav, bottomPosition, containerBottom, headerHeight, navPosition;
      headerHeight = $('header.header--main').height();
      $nav = this.$el.find('nav');
      if ($(window).scrollTop() >= (this.$el.offset().top - headerHeight)) {
        containerBottom = this.$el.offset().top + this.$el.innerHeight();
        bottomPosition = containerBottom - $(window).scrollTop();
        navPosition = $nav.offset().top - $(window).scrollTop() + $nav.innerHeight();
        if (this.$el.data('fixed-position') != null) {
          navPosition = this.$el.data('fixed-position');
        }
        if (bottomPosition <= navPosition) {
          navPosition = ((headerHeight + 10) - $(window).scrollTop()) + $nav.innerHeight();
          this.setInitialFixedPosition();
          if ($nav.hasClass('fixed')) {
            $nav.removeClass('fixed');
          }
          if (!$nav.hasClass('bottom')) {
            return $nav.addClass('bottom');
          }
        } else {
          if ($nav.hasClass('bottom')) {
            $nav.removeClass('bottom');
          }
          if (!$nav.hasClass('fixed')) {
            return $nav.addClass('fixed');
          }
        }
      } else {
        this.unsetInitialFixedPosition();
        if ($nav.hasClass('fixed')) {
          $nav.removeClass('fixed');
        }
        if ($nav.hasClass('bottom')) {
          return $nav.removeClass('bottom');
        }
      }
    };

    return fixedNav;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  ATC.Views.Nav = (function(superClass) {
    extend(Nav, superClass);

    function Nav() {
      return Nav.__super__.constructor.apply(this, arguments);
    }

    Nav.prototype.events = {
      "click [data-toggle-cart]": "toggleCart",
      "click [data-toggle-search]": "toggleSearch",
      "click [data-toggle-login]": "toggleLogin",
      "click [data-toggle-account]": "toggleAccount",
      "click [data-toggle-burger]": "toggleBurger",
      "submit [data-search-form]": "submitSearch",
      "click [data-toggler-nav]": "toggleNav"
    };

    Nav.prototype.initialize = function() {
      return this.render();
    };

    Nav.prototype.render = function() {
      return this.$el.find("[data-sub]").each(function(index, sub) {
        var prev;
        prev = $(sub).prev();
        if (prev.length > 0) {
          if (sub.getAttribute("data-sub") === "right") {
            $(sub).css("left", prev.offset().left - $(sub).width() + prev.width() - 25);
          } else {
            $(sub).css("left", prev.offset().left + 25);
          }
          return $(sub).css("top", prev.offset().top + prev.height() + 10);
        }
      });
    };

    Nav.prototype.submitSearch = function(e) {};

    Nav.prototype.toggleCart = function(e) {
      e.preventDefault();
      $(e.currentTarget).blur();
      return ATC.cart_view.toggle();
    };

    Nav.prototype.toggleSearch = function(e) {
      e.preventDefault();
      $(e.currentTarget).blur();
      return ATC.search_view.toggle();
    };

    Nav.prototype.toggleLogin = function(e) {
      e.preventDefault();
      $(e.currentTarget).blur();
      return ATC.login_view.toggle();
    };

    Nav.prototype.toggleAccount = function(e) {
      e.preventDefault();
      $(e.currentTarget).blur();
      return ATC.account_view.toggle();
    };

    Nav.prototype.toggleNav = function(e) {
      var $parent;
      e.preventDefault();
      $('[data-toggler-nav]').not(e.currentTarget).parent().removeClass('open');
      $parent = $(e.currentTarget).parent();
      $parent.toggleClass('open');
      if (!$parent.hasClass('open')) {
        return $parent.find('nav').slideUp();
      } else {
        return $parent.find('nav').slideDown();
      }
    };

    Nav.prototype.toggleBurger = function(e) {
      $(e.currentTarget).blur();
      if ($("body").hasClass("has_burger")) {
        return this.hide_burger(e);
      } else {
        return this.showBurger(e);
      }
    };

    Nav.prototype.showBurger = function(e) {
      if (e != null) {
        e.preventDefault();
      }
      return $("body").addClass("has_burger");
    };

    Nav.prototype.hide_burger = function(e) {
      if (e != null) {
        e.preventDefault();
      }
      return $("body").removeClass("has_burger");
    };

    return Nav;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  ATC.Views.topLevelCards = (function(superClass) {
    extend(topLevelCards, superClass);

    function topLevelCards() {
      return topLevelCards.__super__.constructor.apply(this, arguments);
    }

    topLevelCards.prototype.initialize = function() {
      return this.reorganize();
    };

    topLevelCards.prototype.reorganize = function() {
      var $collectionCards, $currentCard, $firstCard, currentIndex, self;
      self = this;
      $collectionCards = this.$el.find('[data-toplevel-card]');
      $collectionCards.first().attr('data-first', '');
      $firstCard = $collectionCards.filter('[data-first]');
      $currentCard = $collectionCards.filter('[data-current]');
      currentIndex = $currentCard.index();
      $collectionCards.each(function() {
        if ($(this).index() > currentIndex) {
          return $(this).insertBefore($firstCard);
        }
      });
      $currentCard.remove();
      $collectionCards.each(function() {
        if ($(this).index() > 1) {
          return $(this).remove();
        }
      });
      return this.$el.removeClass('hide');
    };

    return topLevelCards;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  ATC.Views.Carousel = (function(superClass) {
    extend(Carousel, superClass);

    function Carousel() {
      return Carousel.__super__.constructor.apply(this, arguments);
    }

    Carousel.prototype.initialize = function() {
      this.initCarousel();
      this.detectTheme(0, true);
      return this.bindEvents();
    };

    Carousel.prototype.initCarousel = function() {
      var autoplay, fade, options;
      console.log('init carousel');
      autoplay = false;
      if (this.$el.data('autoplay') != null) {
        autoplay = true;
      }
      fade = false;
      if (this.$el.data('fade') != null) {
        fade = true;
      }
      options = {
        dots: true,
        arrows: false,
        autoplay: autoplay,
        autoplaySpeed: 6000,
        fade: fade
      };
      if (this.$el.data('carousel') === "product") {
        options = {
          adaptiveHeight: true,
          fade: true,
          dots: false,
          arrows: true,
          prevArrow: '<div class="slick-prev"><svg class="icon icon--strokes icon--huge"><use xlink:href="#icon-left"></use></svg></div>',
          nextArrow: '<div class="slick-next"><svg class="icon icon--strokes icon--huge"><use xlink:href="#icon-right"></use></svg></div>'
        };
      }
      return this.$el.slick(options);
    };

    Carousel.prototype.bindEvents = function() {
      var self;
      self = this;
      if (this.$el.hasClass('carousel--under')) {
        return this.$el.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
          console.log('before change carousel');
          return self.detectTheme(nextSlide);
        });
      }
    };

    Carousel.prototype.detectTheme = function(index, init) {
      var $nextSlide, data;
      if (init == null) {
        init = false;
      }
      $nextSlide = this.$el.find('.slick-slide').eq(index);
      data = {};
      data['theme'] = 'dark';
      data['init'] = init;
      if (($nextSlide.find('.hero') != null) && $nextSlide.find('.hero').hasClass('hero--dark')) {
        this.$el.addClass('carousel--dark');
      } else {
        data['theme'] = 'light';
        this.$el.removeClass('carousel--dark');
      }
      return $('body').trigger('hero:theme', data);
    };

    return Carousel;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  ATC.Views.Cart = (function(superClass) {
    extend(Cart, superClass);

    function Cart() {
      return Cart.__super__.constructor.apply(this, arguments);
    }

    Cart.prototype.el = $("#cart");

    Cart.prototype.template = templates["cart"];

    Cart.prototype.data = {};

    Cart.prototype.events = {
      "click [data-remove-from-cart]": "remove_from_cart",
      "click [data-increment]": "increment",
      "click [data-decrement]": "decrement",
      "click [data-close-error]": "close_error",
      "click [data-hide]": "hide"
    };

    Cart.prototype.initialize = function() {
      this.listenTo(this.model, "sync", this.render);
      return this.render();
    };

    Cart.prototype.render = function() {
      console.log('render cart');
      _.extend(this.data, {
        model: this.model.toJSON(),
        text: window.cart_text
      });
      this.$el.html(this.template(this.data));
      $("[data-item-count]").text(this.model.get("item_count"));
      return this;
    };

    Cart.prototype.toggle = function(e) {
      if (this.$el.hasClass("cart--show")) {
        return this.hide(e);
      } else {
        return this.show(e);
      }
    };

    Cart.prototype.show = function(e) {
      if (e != null) {
        e.preventDefault();
      }
      this.$el.addClass("cart--show");
      return $('body').addClass('body--freeze');
    };

    Cart.prototype.hide = function(e) {
      if (e != null) {
        e.preventDefault();
      }
      this.$el.removeClass("cart--show");
      return $('body').removeClass('body--freeze');
    };

    Cart.prototype.remove_from_cart = function(e) {
      e.preventDefault();
      return ATC.cart.remove($(e.currentTarget).attr("data-remove-from-cart"));
    };

    Cart.prototype.increment = function(e) {
      e.preventDefault();
      return ATC.cart.change($(e.currentTarget).attr("data-increment"), parseInt($(e.currentTarget).attr("data-current-quantity")) + 1);
    };

    Cart.prototype.decrement = function(e) {
      e.preventDefault();
      return ATC.cart.change($(e.currentTarget).attr("data-decrement"), parseInt($(e.currentTarget).attr("data-current-quantity")) - 1);
    };

    Cart.prototype.show_error = function(error) {
      this.$el.find("[data-cart-error-text]").text(error);
      return this.$el.find("[data-cart-error]").removeClass("fade_out");
    };

    Cart.prototype.close_error = function(e) {
      e.preventDefault();
      return this.$el.find("[data-cart-error]").addClass("fade_out");
    };

    return Cart;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  ATC.Views.Collection = (function(superClass) {
    extend(Collection, superClass);

    function Collection() {
      return Collection.__super__.constructor.apply(this, arguments);
    }

    Collection.prototype.events = {
      "click [data-filter-tag]": "filter_tag",
      "click [data-scroll-to]": "scroll_to"
    };

    Collection.prototype.filters = [];

    Collection.prototype.initialize = function() {
      console.log("Collection: " + this.$el.attr("data-collection-id"));
      return this.render();
    };

    Collection.prototype.render = function() {
      this.sticks = this.$el.find("[data-sticks]");
      if (this.sticks.length > 0) {
        this.offset = this.sticks.offset().top;
        if (window.innerWidth > 600) {
          this.check_scroll();
          $(window).on("scroll", this.check_scroll.bind(this));
        }
      }
      return this;
    };

    Collection.prototype.filter_tag = function(e) {
      var filter, i, len, ref, results;
      if (e.currentTarget.checked) {
        this.filters.push(e.currentTarget.value);
        this.$el.find(".product." + e.currentTarget.value).first().velocity("scroll", {
          duration: 1666,
          easing: "easeOutQuart",
          offset: -80
        });
      } else {
        this.filters = _.without(this.filters, e.currentTarget.value);
      }
      if (this.filters.length) {
        this.$el.find(".product").addClass("product--disabled");
        ref = this.filters;
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          filter = ref[i];
          results.push(this.$el.find(".product." + filter).removeClass("product--disabled").addClass("product--highlight"));
        }
        return results;
      } else {
        return this.$el.find(".product").removeClass("product--disabled").removeClass("product--highlight");
      }
    };

    Collection.prototype.scroll_to = function(e) {
      var scroll_to;
      scroll_to = $("#" + e.currentTarget.getAttribute("data-scroll-to"));
      if (scroll_to.length > 0) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return scroll_to.velocity("scroll", {
          duration: 1666,
          easing: "easeOutQuart",
          offset: -80
        });
      }
    };

    Collection.prototype.check_scroll = function(e) {
      if (window.pageYOffset > this.offset - 100) {
        if (!this.sticks.hasClass("sticks--fixed")) {
          return this.sticks.addClass("sticks--fixed");
        }
      } else {
        if (this.sticks.hasClass("sticks--fixed")) {
          return this.sticks.removeClass("sticks--fixed");
        }
      }
    };

    Collection.prototype.undelegateEvents = function() {
      $(window).off("scroll", this.check_scroll);
      return Collection.__super__.undelegateEvents.call(this);
    };

    return Collection;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  ATC.Views.Feed = (function(superClass) {
    extend(Feed, superClass);

    function Feed() {
      return Feed.__super__.constructor.apply(this, arguments);
    }

    Feed.prototype.template = templates["feed"];

    Feed.prototype.data = {};

    Feed.prototype.events = {};

    Feed.prototype.initialize = function() {
      this.feed = new ATC.Collections.Feed({
        user_id: this.$el.attr("data-feed-user-id"),
        access_token: this.$el.attr("data-feed-access-token"),
        limit: this.$el.attr("data-feed-limit")
      });
      this.listenTo(this.feed, "sync", this.render);
      this.width = this.$el.attr("data-feed-photo-width") + "%";
      return this.render();
    };

    Feed.prototype.render = function() {
      _.extend(this.data, {
        feed: this.feed.toJSON(),
        width: this.width
      });
      this.$el.html(this.template(this.data));
      return this;
    };

    return Feed;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  ATC.Views.Filters = (function(superClass) {
    extend(Filters, superClass);

    function Filters() {
      return Filters.__super__.constructor.apply(this, arguments);
    }

    Filters.prototype.events = {};

    Filters.prototype.initialize = function() {
      return Filters.__super__.initialize.call(this);
    };

    Filters.prototype.render = function() {
      return Filters.__super__.render.call(this);
    };

    return Filters;

  })(ATC.Views.Nav);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  ATC.Views.Footer = (function(superClass) {
    extend(Footer, superClass);

    function Footer() {
      return Footer.__super__.constructor.apply(this, arguments);
    }

    Footer.prototype.events = {
      "click [data-show-newsletter]": "showNewsletter"
    };

    Footer.prototype.initialize = function() {
      return this.initFirstWord();
    };

    Footer.prototype.initFirstWord = function() {
      return $('[data-first-word]').each(function() {
        var firstWord, firstWordPosition, rest, string;
        string = $(this).html();
        firstWordPosition = string.indexOf(" ");
        firstWord = string.substr(0, firstWordPosition);
        rest = string.substr(firstWordPosition + 1);
        string = firstWord + ' <span>' + rest + '</span>';
        return $(this).html(string);
      });
    };

    Footer.prototype.showNewsletter = function(e) {
      e.preventDefault();
      ATC.newsletter_view.show();
      return ATC.newsletter_view.$el.find("[name='email']").focus();
    };

    return Footer;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  ATC.Views.Header = (function(superClass) {
    extend(Header, superClass);

    function Header() {
      return Header.__super__.constructor.apply(this, arguments);
    }

    Header.prototype.theme = null;

    Header.prototype.initialize = function() {
      return this.render();
    };

    Header.prototype.events = {
      "click [data-menu-toggler]": "toggleMenu",
      "click [data-nav-toggler]": "toggleNav"
    };

    Header.prototype.render = function() {
      this.checkScroll();
      $(window).on("scroll", this.checkScroll.bind(this));
      return $('body').on('hero:theme', (function(_this) {
        return function(e, data) {
          var init, theme;
          theme = data.theme;
          init = data.init;
          return _this.changeTheme(theme, init);
        };
      })(this));
    };

    Header.prototype.checkScroll = function(e) {
      if (window.pageYOffset > 0) {
        if (!this.$el.hasClass("header--scrolled")) {
          return this.$el.addClass("header--scrolled");
        }
      } else {
        if (this.$el.hasClass("header--scrolled")) {
          return this.$el.removeClass("header--scrolled");
        }
      }
    };

    Header.prototype.undelegateEvents = function() {
      $(window).off("scroll", this.checkScroll);
      return Header.__super__.undelegateEvents.call(this);
    };

    Header.prototype.changeTheme = function(theme, init) {
      if (init == null) {
        init = false;
      }
      if (this.theme !== theme) {
        if (init === true) {
          this.$el.addClass('header--noanimation');
          setTimeout((function(_this) {
            return function() {
              return _this.$el.removeClass('header--noanimation');
            };
          })(this), 400);
        }
        this.$el.addClass('header--' + theme);
        this.$el.removeClass('header--' + this.theme);
        return this.theme = theme;
      }
    };

    return Header;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  ATC.Views.Hero = (function(superClass) {
    extend(Hero, superClass);

    function Hero() {
      return Hero.__super__.constructor.apply(this, arguments);
    }

    Hero.prototype.initialize = function() {
      return this.detectTheme();
    };

    Hero.prototype.detectTheme = function() {
      if (this.$el.hasClass('hero--under')) {
        if (this.$el.hasClass('hero--dark')) {
          return $('body').trigger('hero:theme', 'dark');
        } else {
          return $('body').trigger('hero:theme', 'light');
        }
      }
    };

    return Hero;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  ATC.Views.Login = (function(superClass) {
    extend(Login, superClass);

    function Login() {
      return Login.__super__.constructor.apply(this, arguments);
    }

    Login.prototype.el = $("#login");

    Login.prototype.data = {};

    Login.prototype.events = {
      "click [data-hide]": "hide",
      "submit #customer_login": "customer_login",
      "submit #create_customer": "create_customer",
      "click [data-submit]": "submit_form",
      "click [data-slide-marker]": "slide_to"
    };

    Login.prototype.initialize = function() {
      return Login.__super__.initialize.call(this);
    };

    Login.prototype.render = function() {
      return Login.__super__.render.call(this);
    };

    Login.prototype.customer_login = function(e) {
      e.preventDefault();
      return $.ajax(e.currentTarget.getAttribute("action"), {
        method: "POST",
        dataType: "html",
        data: {
          "customer[email]": e.currentTarget["customer[email]"].value,
          "customer[password]": e.currentTarget["customer[password]"].value,
          form_type: "customer_login",
          utf8: "✓"
        },
        success: (function(_this) {
          return function(response) {
            var errors;
            errors = $(response).find(".errors");
            if (errors.length > 0) {
              return $(e.currentTarget).find("[data-errors]").text(errors.text());
            } else {
              $(e.currentTarget).find("[data-errors]").text("");
              window.location.reload();
              return _this.hide();
            }
          };
        })(this)
      });
    };

    Login.prototype.create_customer = function(e) {
      e.preventDefault();
      return $.ajax(e.currentTarget.getAttribute("action"), {
        method: "POST",
        data: {
          "customer[email]": e.currentTarget["customer[email]"].value,
          "customer[password]": e.currentTarget["customer[password]"].value,
          "customer[first_name]": e.currentTarget["customer[first_name]"].value,
          "customer[last_name]": e.currentTarget["customer[last_name]"].value,
          form_type: "create_customer",
          utf8: "✓"
        },
        success: (function(_this) {
          return function(response) {
            var errors;
            errors = $(response).find(".errors");
            if (errors.length > 0) {
              return $(e.currentTarget).find("[data-errors]").text(errors.text());
            } else {
              $(e.currentTarget).find("[data-errors]").text("");
              Turbolinks.visit("/account");
              return _this.hide();
            }
          };
        })(this)
      });
    };

    Login.prototype.toggle = function(e) {
      if (this.$el.hasClass("overlay--show")) {
        return this.hide(e);
      } else {
        return this.show(e);
      }
    };

    Login.prototype.show = function(e, index) {
      if (index == null) {
        index = 0;
      }
      if (e != null) {
        e.preventDefault();
      }
      this.$el.find("#login_email").focus();
      return this.$el.addClass("overlay--show");
    };

    Login.prototype.hide = function(e) {
      if (e != null) {
        e.preventDefault();
      }
      return this.$el.removeClass("overlay--show");
    };

    return Login;

  })(ATC.Views.Slider);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  ATC.Views.Newsletter = (function(superClass) {
    extend(Newsletter, superClass);

    function Newsletter() {
      return Newsletter.__super__.constructor.apply(this, arguments);
    }

    Newsletter.prototype.data = {};

    Newsletter.prototype.events = {
      "click [data-trigger-submit]": "triggerSubmit"
    };

    Newsletter.prototype.initialize = function() {};

    Newsletter.prototype.signup = function(e) {
      var language;
      e.preventDefault();
      language = 'fr';
      if (window.location.hostname.indexOf('en.') !== -1) {
        language = 'en';
      }
      return $.ajax("https://shopify.destruct.codes/_newsletter/signup", {
        method: "POST",
        contentType: "application/json",
        data: JSON.stringify({
          email: e.currentTarget["email"].value,
          shop: e.currentTarget["shop"].value,
          language: language
        }),
        success: (function(_this) {
          return function(response) {
            ATC.cookies.set("newsletter_hidden", true);
            _this.toggleSection('success');
            return setTimeout(function() {
              return _this.hide();
            }, 3000);
          };
        })(this),
        error: (function(_this) {
          return function(response) {
            debugger;
            return $(e.currentTarget).find("[data-errors]").text(response.responseJSON.error);
          };
        })(this)
      });
    };

    Newsletter.prototype.toggleSection = function(section) {
      $('[data-section]').addClass('hide');
      return $('[data-section="' + section + '"]').removeClass('hide');
    };

    Newsletter.prototype.triggerSubmit = function() {
      return this.$el.find('[data-newsletter-form]').trigger('submit');
    };

    return Newsletter;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  ATC.Views.Product = (function(superClass) {
    extend(Product, superClass);

    function Product() {
      return Product.__super__.constructor.apply(this, arguments);
    }

    Product.prototype.events = {
      "click [name='color']": "changeVariant",
      "click [data-thumb-img]": "showImage",
      "submit [data-add-to-cart-form]": "addToCart",
      "click [data-show-sizing]": "showSizing",
      "click [data-hide-sizing]": "hideSizing",
      "click [data-product-option]": "chooseSelect",
      "click [data-product-label]": "toggleSelect",
      "focus [data-date]": "focusDate",
      "mouseleave [data-product-select]": "closeSelect"
    };

    Product.prototype.initialize = function() {
      return this.render();
    };

    Product.prototype.render = function() {
      this.assignVariantsColors();
      this.initializeCarousel();
      this.setEstimatedDate();
      return this.initDatePicker();
    };

    Product.prototype.initDatePicker = function() {
      // date format is mm/dd/yy
      console.log('init datepicker');
      var dateEl, datepicker, dayIncrement, lang, maxDate, minDate, settings, stValentineDates, today;
      dateEl = document.querySelector('input[data-date]');
      today = new Date();
      minDate = new Date();
      dayIncrement = 1;
      minDate.setDate(today.getDate() + (dateEl.getAttribute('data-special-type') === 'funeraire' ? 2 : dayIncrement));
      maxDate = new Date(minDate);
      maxDate = maxDate.setMonth(maxDate.getMonth() + 2);

      if (dateEl.getAttribute('data-special-type') === 'rosh10') {
        var rosh10MaxDate = new Date("11/30/26");

        if (today < rosh10MaxDate) {
          var rosh10MinDate = new Date("09/10/26");

          if (minDate < rosh10MinDate){
            minDate = rosh10MinDate;
          }

          maxDate = rosh10MaxDate;
        }
      }
      
      if (dateEl.getAttribute('data-special-type') === 'couronne') {
        var couronneMaxDate = new Date("12/18/26");

        if (today < couronneMaxDate) {
          var couronneMinDate = new Date("11/13/26");

          if(minDate < couronneMinDate){
            minDate = couronneMinDate;
          }

          maxDate = couronneMaxDate;
        }
      }

      /*if (dateEl.getAttribute('data-special-type') === 'fetedesmeres') {
        var fetedesmeresMaxDate = new Date("05/10/26");

        if (today < fetedesmeresMaxDate) {
          var fetedesmeresMinDate = new Date("05/05/26");

          if (minDate < fetedesmeresMinDate){
            minDate = fetedesmeresMinDate;
          }

          maxDate = fetedesmeresMaxDate;
        }
      }
      
      if (dateEl.getAttribute('data-special-type') === 'couronne') {
        minDate = minDate.setDate(today.getDate() + 3);
        var couronneMinDate = new Date("11/07/25");
        var couronneMaxDate = new Date("12/19/25");

        if (today < couronneMaxDate) {
          if(minDate < couronneMinDate){
            minDate = couronneMinDate;
          }

          maxDate = couronneMaxDate;
        }
      }

      if (dateEl.getAttribute('data-special-type') === 'saintvalentin') {
        var saintValentinMinDate = new Date("02/11/26");
        var saintValentinMaxDate = new Date("02/15/26");

        if (today < saintValentinMaxDate) {
          if(minDate < saintValentinMinDate){
            minDate = saintValentinMinDate;
          }

          maxDate = saintValentinMaxDate;
        }
      }

      if (dateEl.getAttribute('data-special-type') === 'lunaire') {
        var lunaireMinDate = new Date("02/15/26");
        var lunaireMaxDate = new Date("03/04/26");

        if (today < lunaireMaxDate) {
          if(minDate < lunaireMinDate){
            minDate = lunaireMinDate;
          }

          maxDate = lunaireMaxDate;
        }
      }

      if (dateEl.getAttribute('data-special-type') === 'journeefemme') {
        var journeeFemmeMinDate = new Date("02/23/26");
        var journeeFemmeMaxDate = new Date("03/09/26");

        if (today < journeeFemmeMaxDate) {
          if(minDate < journeeFemmeMinDate){
            minDate = journeeFemmeMinDate;
          }

          maxDate = journeeFemmeMaxDate;
        }
      }

      if (dateEl.getAttribute('data-special-type') === 'paques') {
        var paquesMinDate = new Date("03/09/26");
        var paquesMaxDate = new Date("04/20/26");

        if (today < paquesMaxDate) {
          if(minDate < paquesMinDate){
            minDate = paquesMinDate;
          }

          maxDate = paquesMaxDate;
        }
      }*/
      
      if (dateEl.getAttribute('data-lang') === 'en') {
        lang = 'en';
      } else {
        lang = 'fr';
      }

      settings = {
        language: lang,
        minDate: minDate,
        maxDate: maxDate,
        format: 'dd/mm/yyyy',
        beforeShowDay: this.checkDisabledDates
      };
      
      return datepicker = new Datepicker(dateEl, settings);
    };

    Product.prototype.checkDisabledDates = function(date){
      // year-month-day
      var disabledDates = ["2026-1-19", "2026-1-20", "2026-1-21", "2026-4-5", "2026-5-11", "2026-6-24", "2026-7-1"]

      // Should probably import a lib
      var stringDate = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()
      return disabledDates.indexOf(stringDate) == -1
    }

    Product.prototype.setEstimatedDate = function() {
      var day, dayIncrement, monthIndex, monthNames, nextDay, nextDayFormat, today, tomorrow, year;
      if (this.$el.find('[data-estimated-date]')) {
        today = new Date();
        dayIncrement = 1;
        /*if (today.getDay() === 1) {
          dayIncrement = 2;
        }*/
        nextDay = today.setDate(today.getDate() + dayIncrement);
        tomorrow = new Date(nextDay);
        monthNames = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"];
        day = tomorrow.getDate();
        monthIndex = tomorrow.getMonth();
        year = tomorrow.getFullYear();
        nextDayFormat = day + ' ' + monthNames[monthIndex] + ' ' + year;
        return this.$el.find('[data-estimated-date]').html(nextDayFormat);
      }
    };

    Product.prototype.assignVariantsColors = function() {
      return _.each(variant_colors, (function(_this) {
        return function(color, key) {
          return _this.$el.find("label[title='" + key + "']").css("background", color);
        };
      })(this));
    };

    Product.prototype.changeVariant = function(e) {
      var i, id, key, len, ref, size, sizes;
      sizes = JSON.parse(e.currentTarget.getAttribute("data-sizes"));
      size = this.$el.find("[name='size']:checked").attr("data-size");
      id = null;
      ref = _.keys(sizes);
      for (i = 0, len = ref.length; i < len; i++) {
        key = ref[i];
        id = sizes[size];
        if (id == null) {
          id = sizes[key];
        }
        break;
      }
      console.log(id);
      if (id != null) {
        return Turbolinks.visit(window.location.pathname + "?variant=" + id);
      } else {
        return Turbolinks.visit(window.location.pathname + "?variant=" + e.currentTarget.value);
      }
    };

    Product.prototype.showImage = function(e) {
      var $image, $thumb;
      e.preventDefault();
      $thumb = this.$el.find("[data-thumb-img]");
      $image = this.$el.find("[data-featured-img]");
      $thumb.removeClass('active');
      $(e.currentTarget).addClass('active');
      $image.attr("src", $(e.currentTarget).data("img-src"));
      Turbolinks.controller.adapter.progressBar.setValue(0);
      Turbolinks.controller.adapter.progressBar.show();
      return $image.on("load", (function(_this) {
        return function() {
          Turbolinks.controller.adapter.progressBar.setValue(100);
          return Turbolinks.controller.adapter.progressBar.hide();
        };
      })(this));
    };

    Product.prototype.showSizing = function(e) {
      var $sizing;
      e.preventDefault();
      $sizing = $('[data-sizing]');
      $sizing.addClass('overlay--show');
      return $('body').addClass('body--freeze');
    };

    Product.prototype.hideSizing = function(e) {
      var $sizing;
      e.preventDefault();
      $sizing = $('[data-sizing]');
      $sizing.removeClass('overlay--show');
      return $('body').removeClass('body--freeze');
    };

    Product.prototype.initializeCarousel = function() {
      return this.$el.find('.product__thumbs').slick({
        mobileFirst: true,
        infinite: true,
        draggable: true,
        dots: true,
        responsive: [
          {
            breakpoint: 600,
            settings: 'unslick'
          }
        ]
      });
    };

    Product.prototype.addToCart = function(e, data) {
      if (data == null) {
        data = {};
      }
      e.preventDefault();
      e.stopImmediatePropagation();
      if ($(e.currentTarget).find('[name="properties[date]"]').length) {
        if ($(e.currentTarget).find('[name="properties[date]"]').val() !== '') {
          data['date'] = $(e.currentTarget).find('[name="properties[date]"]').val();
        } else {
          return this.showError($(e.currentTarget).find('[name="properties[date]"]'));
        }
      }
      if ($(e.currentTarget).find('[name="properties[message]"]').length && $(e.currentTarget).find('[name="properties[message]"]').val() !== "") {
        data['message'] = $(e.currentTarget).find('[name="properties[message]"]').val();
      }
      if ($(e.currentTarget).find('[name="properties[preferences]"]').length && $(e.currentTarget).find('[name="properties[preferences]"]').val() !== "") {
        data['preferences'] = $(e.currentTarget).find('[name="properties[preferences]"]').val();
      }
      if (this.$el.find("[name='id']:checked").length) {
        console.log(this.$el.find("[name='id']:checked").val());
        ATC.cart.add(this.$el.find("[name='id']:checked").val(), 1, data);
        return ATC.cart_view.show();
      } else {
        return this.showError(this.$el.find('[data-size-select]'));
      }
    };

    Product.prototype.chooseSelect = function(e) {
      var $select, optionHtml, variantId;
      if ($(e.currentTarget).data('disabled') == null) {
        optionHtml = $(e.currentTarget).html();
        variantId = $(e.currentTarget).data('product-option');
        $select = $(e.currentTarget).closest('[data-product-select]');
        $select.find('[data-product-option]').removeClass('active');
        $(e.currentTarget).addClass('active');
        $('[data-product-label]', $select).html(optionHtml);
        if ($(e.currentTarget).data('product-option1') != null) {
          this.$el.find("[name='option1']").val($(e.currentTarget).data('product-option1'));
          this.selectVariant();
        } else if ($(e.currentTarget).data('product-option2') != null) {
          this.$el.find("[name='option2']").val($(e.currentTarget).data('product-option2'));
          this.selectVariant();
        } else if ($(e.currentTarget).data('product-option3') != null) {
          this.$el.find("[name='option3']").val($(e.currentTarget).data('product-option3'));
          this.selectVariant();
        }
        return $select.removeClass('open');
      }
    };

    Product.prototype.selectVariant = function(e) {
      var option1, option2, option3;
      if (this.$el.find("[name='option1']").length) {
        option1 = this.$el.find("[name='option1']").val();
      }
      if (this.$el.find("[name='option2']").length) {
        option2 = this.$el.find("[name='option2']").val();
      }
      if (this.$el.find("[name='option3']").length) {
        option3 = this.$el.find("[name='option3']").val();
      }
      
      var val = $('input[name="id"]' + 
        (option1 ? '[data-option1="' + option1 + '"]' : '') + 
        (option2 ? '[data-option2="' + option2 + '"]' : '') + 
        (option3 ? '[data-option3="' + option3 + '"]' : ''));

      if (val.length > 0)
      {
        // Only show price when multiple options available, if not it is shown directly in the comboBox
        if (val.length == 1 && option2)
        {
          var priceSpan = document.getElementById('PriceTag');
          priceSpan.textContent = val[0].getAttribute('price');
          var priceDiv = document.getElementById('Price');
          priceDiv.style.display = "";
        }

        return val.prop('checked', 'checked');
      }
    };

    Product.prototype.toggleSelect = function(e) {
      var $select;
      $select = $(e.currentTarget).closest('[data-product-select]');
      this.$el.find('[data-product-select]').not($select).removeClass('open');
      $select.toggleClass('open');
      return $select.removeClass('error');
    };

    Product.prototype.focusDate = function(e) {
      return $(e.currentTarget).removeClass('error');
    };

    Product.prototype.closeSelect = function(e) {
      return $(e.currentTarget).removeClass('open');
    };

    Product.prototype.showError = function($el) {
      return $el.addClass('error');
    };

    return Product;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  ATC.Views.CustomProduct = (function(superClass) {
    extend(CustomProduct, superClass);

    function CustomProduct() {
      return CustomProduct.__super__.constructor.apply(this, arguments);
    }

    CustomProduct.prototype.events = {
      "click [name='variant']": "change_variant",
      "click [data-add-product]": "add_product",
      "click [data-add-to-cart]": "add_to_cart",
      "click [data-product-spot]": "remove_product"
    };

    CustomProduct.prototype.products = [];

    CustomProduct.prototype.size = 0;

    CustomProduct.prototype.initialize = function() {
      CustomProduct.__super__.initialize.call(this);
      return console.log("Custom!");
    };

    CustomProduct.prototype.render = function() {
      var i, index, len, product, ref;
      this.size = parseInt(this.$el.attr("data-custom-size"));
      if (this.size < this.products.length) {
        this.products = this.products.slice(0, this.size);
      }
      this.spots = this.$el.find("[data-product-spot]");
      this.spots.attr("data-product-spot", "");
      this.spots.attr("src", "");
      ref = this.products;
      for (index = i = 0, len = ref.length; i < len; index = ++i) {
        product = ref[index];
        this.spots[index].setAttribute("data-product-spot", product.title);
        this.spots[index].setAttribute("src", product.image);
      }
      this.$el.find("[data-add-to-cart]").attr("disabled", this.products.length !== this.size);
      return CustomProduct.__super__.render.call(this);
    };

    CustomProduct.prototype.add_to_cart = function(e, data) {
      var i, len, product, products_text, ref;
      if (data == null) {
        data = {};
      }
      products_text = "";
      ref = this.products;
      for (i = 0, len = ref.length; i < len; i++) {
        product = ref[i];
        products_text += product.title + ", ";
      }
      data["properties[" + this.$el.attr("data-custom-label") + "]"] = products_text.substring(0, products_text.length - 2);
      return CustomProduct.__super__.add_to_cart.call(this, e, data);
    };

    CustomProduct.prototype.add_product = function(e) {
      e.preventDefault();
      if (this.products.length < this.size) {
        this.products.push({
          title: e.currentTarget.getAttribute("data-add-product"),
          image: e.currentTarget.getAttribute("data-add-product-image")
        });
        return this.render();
      }
    };

    CustomProduct.prototype.remove_product = function(e) {
      e.preventDefault();
      this.products.splice(this.spots.index(e.currentTarget), 1);
      return this.render();
    };

    return CustomProduct;

  })(ATC.Views.Product);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  ATC.Views.Search = (function(superClass) {
    extend(Search, superClass);

    function Search() {
      return Search.__super__.constructor.apply(this, arguments);
    }

    Search.prototype.el = $("#search");

    Search.prototype.data = {};

    Search.prototype.events = {
      "click [data-hide]": "hide"
    };

    Search.prototype.initialize = function() {
      return this.render();
    };

    Search.prototype.render = function() {
      return this;
    };

    Search.prototype.toggle = function(e) {
      if (this.$el.hasClass("overlay--show")) {
        return this.hide(e);
      } else {
        return this.show(e);
      }
    };

    Search.prototype.show = function(e) {
      if (e != null) {
        e.preventDefault();
      }
      this.$el.addClass("overlay--show");
      $('body').addClass('body--freeze');
      return this.$el.find("[type='search']").focus();
    };

    Search.prototype.hide = function(e) {
      if (e != null) {
        e.preventDefault();
      }
      this.$el.removeClass("overlay--show");
      return $('body').removeClass('body--freeze');
    };

    return Search;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  ATC.Views.StaticPage = (function(superClass) {
    extend(StaticPage, superClass);

    function StaticPage() {
      return StaticPage.__super__.constructor.apply(this, arguments);
    }

    StaticPage.prototype.initialize = function() {
      this.$images = this.$el.find('[data-carousel-image]');
      if (this.$images.length) {
        this.createCarousel();
        this.appendImages();
        return this.initializeCarousel();
      }
    };

    StaticPage.prototype.createCarousel = function() {
      var carousel, dataCarousel, section, title;
      section = document.createElement('section');
      section.className = 'text_center';
      $(section).insertAfter(this.$images.first());
      title = document.createElement('h2');
      title.className = 'medium_bottom';
      section.appendChild(title);
      $(title).html(this.$el.data('carousel-title'));
      carousel = document.createElement('div');
      dataCarousel = document.createAttribute('data-carousel');
      carousel.className = 'slick-slider--guttered';
      carousel.setAttributeNode(dataCarousel);
      this.$carousel = $(carousel);
      return section.appendChild(carousel);
    };

    StaticPage.prototype.appendImages = function() {
      var self;
      self = this;
      return this.$images.each(function() {
        return self.$carousel.append($(this));
      });
    };

    StaticPage.prototype.initializeCarousel = function() {
      return this.$carousel.slick({
        slidesToShow: 1,
        centerMode: true,
        centerPadding: '100px',
        infinite: true,
        arrows: true,
        draggable: false,
        prevArrow: '<span class="slick-prev slick-arrow--light"><svg class="icon"><use xlink:href="#icon-left"></use></svg></span>',
        nextArrow: '<span class="slick-next slick-arrow--light"><svg class="icon"><use xlink:href="#icon-right"></use></svg></span>',
        responsive: [
          {
            breakpoint: 900,
            settings: {
              arrows: false,
              infinite: true,
              dots: true,
              draggable: true,
              dotsClass: 'slick-dots slick-dots--light'
            }
          }
        ]
      });
    };

    return StaticPage;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  ATC.Views.Video = (function(superClass) {
    extend(Video, superClass);

    function Video() {
      return Video.__super__.constructor.apply(this, arguments);
    }

    Video.prototype.initialize = function() {
      return this.$el.fitVids();
    };

    return Video;

  })(Backbone.View);

}).call(this);
